export default "__VITE_ASSET__DM3ZFOK6__"